import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxFeedbackCreatorComponent } from './feedback-creator.component';

// TODO - remove when feedbackSession ngx STAB-680
export { FeedbackCreatorModule } from './feedback-creator.module';
export const ngxFeedbackCreatorModule = angular.module('ngxFeedbackCreatorModule', [])
	.directive('ngxFeedbackCreator', downgradeComponent({ component: NgxFeedbackCreatorComponent }))
	.name;
